<template>
  <DialogRoot v-model:open="model">
    <DialogPortal>
      <Transition
        enter-active-class="transition duration-500 ease-smooth"
        enter-from-class="opacity-0"
        enter-to-class="opacity-100"
        leave-active-class="transition duration-500 delay-100 ease-smooth"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0">
        <DialogOverlay class="bg-primary-80/80 fixed inset-0 z-30" />
      </Transition>

      <slot />
    </DialogPortal>
  </DialogRoot>
</template>

<script setup lang="ts">
import { DialogOverlay, DialogPortal, DialogRoot } from 'radix-vue'

const model = defineModel<boolean>()
</script>
